import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useEffect, useState } from 'react'
import { Grid } from '@mui/material';
import { FieldValues, useForm } from 'react-hook-form';
import { PeopleService } from '../../../../Component/Api/People/peopleService';
import { AppDatepicker } from '../../../../Component/Common/Components/FormValidationInputs/AppDatepicker';
import AppSelectList, { IDropDownOptions } from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import AppTextInput from '../../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { positionSchema } from './PositionValidation';
import { LoadingButton } from '@mui/lab';
import { PeopleDtos } from '../../../../Component/Model/Dto/People';
import { toast } from 'react-toastify';
import AppCheckbox from '../../../../Component/Common/Components/FormValidationInputs/AppCheckbox';
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';
import { offsetTimezone } from '../../../../Component/Model/helpers';
import { isArray } from 'lodash';

interface IEmploymentModalProps {
    personId: number;
    employeeId: number;
    displayPositionModal: boolean;
    closePositionModal: () => void;
}

const OccupationalLevelList: IDropDownOptions[] = [
    { value: "Unknown Value", id: -1 },
    { value: "Executive Director", id: 1 },
    { value: "Non Executive Director", id: 2 },
    { value: "Executive Management", id: 3 },
    { value: "Other Executive Management", id: 4 },
    { value: "Senior Management", id: 5 },
    { value: "Middle Management", id: 6 },
    { value: "Junior Management", id: 7 },
    { value: "Semi skilled", id: 8 },
    { value: "Unskilled", id: 9 },
    { value: "Unspecified", id: 10 }
]

    const OccupationalLevelPositionList: IDropDownOptions[] = [
        { value: "Executive Director", id: 1 },
        { value: "Non Executive Director", id: 2 },
        { value: "Other Executive Management", id: 4 },
        { value: "Senior Management", id: 5 },
        { value: "Middle Management", id: 6 },
        { value: "Junior Management", id: 7 },
        { value: "Semi skilled", id: 8 },
        { value: "Unskilled", id: 9 },
        { value: "Unspecified", id: 10 }
    ]

    const EmployeeLevelList: IDropDownOptions[] = [
        { value: "Employee", id: 1 },
        { value: "Employed by Other", id: 2 },
        { value: "Unemployed", id: 3 },
        { value: "Employee Previously Unemployed", id: 4 },
    ]

const PositionModal = (props: IEmploymentModalProps) => {
    const [employeeId, setEmployeeId] = useState<number>(props.employeeId);
    const [startDate, setStartDate] = useState<Date | undefined>(undefined);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const { control, reset, handleSubmit, formState: { isSubmitting }, setValue, getValues } = useForm({
        mode: 'all',
        resolver: yupResolver(positionSchema)
    });

    const getDataFromApi = async () => {
        const result = await PeopleService.GetPosition(props.employeeId);
        reset(result.data);
    }
    const handleDataSubmit = async (data: FieldValues) => {
        const position = data as PeopleDtos.GetPersonEmploymentRequest;
        if (position.startDate != null) {
            position.startDate = offsetTimezone(new Date(position.startDate.toDateString()));
        }
        if (position.endDate != null) {
            position.endDate = offsetTimezone(new Date(position.endDate.toDateString()));
        }
        try {
            if (employeeId === 0) {
                position.personId = props.personId;
                const result = await PeopleService.CreatePosition(position);
                setEmployeeId(result.data.id);
                reset(result.data);
                toast.success('Position Created Successfully');
            } else {

                const result = await PeopleService.UpdatePosition(position);
                toast.success('Position Updated Successfully');
            }
        } catch (error: any) {
            if (isArray(error.response.data)) {
                let Errors: string[] = error.response.data;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }

    }

    useEffect(() => {
        if (props.employeeId !== 0) {
            getDataFromApi();
        }
        else {
            setValue('isPermanent', true);
        }

    }, [])


    return (
        <Dialog disableEnforceFocus open={props.displayPositionModal} onClose={() => { props.closePositionModal() }} aria-labelledby="form-dialog-title" maxWidth='lg'>
            <CustomDialogTitle id="customized-dialog-title" onClose={() => props.closePositionModal()}>
                {employeeId === 0 ? 'Capture new Position' : 'Edit Position'}
            </CustomDialogTitle>
            <DialogContent>
                <Box>
                    <form onSubmit={handleSubmit(handleDataSubmit)} id='PositionForm'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} mt={1}>
                                <AppSelectList control={control} name='occupationalLevelId' label='Occupational Level' items={OccupationalLevelPositionList} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppSelectList control={control} name='employeeTypeId' label='Employment Type' items={EmployeeLevelList} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name='positionName' label='Position' />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppDatepicker control={control} name='startDate' label='Start Date' inputFormat='yyyy/MM/dd' maxDate={endDate} onChange={setStartDate} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppDatepicker control={control} name='endDate' label='End Date' inputFormat='yyyy/MM/dd' minDate={startDate} onChange={setEndDate} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name='ofoCode' label='OFO code' />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppCheckbox control={control} name='isPermanent' label='Permanent Position' disabled={false} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppCheckbox control={control} name='trainingReceived' label='Received Training?' disabled={false} />
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </DialogContent>
            <DialogActions>
                <Box>
                    <LoadingButton loading={isSubmitting} variant='contained' type="submit" color='primary' form='PositionForm'>Save</LoadingButton>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default PositionModal